import { createGlobalStyle } from 'styled-components/macro';
import { normalize } from '@styled/modern-normalize'

export const ResetStyles = createGlobalStyle`
  ${normalize}
`;
